import actions from './actions';
import getters from './getters';
import mutations from './mutations';
export var state = function state() {
  return {
    currentImage: null,
    product: null,
    productInspiration: null,
    productCross: null,
    productComplementary: null,
    productXsellAddToCart: null,
    variants: [],
    productRR: null
  };
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};